import aa from 'search-insights';
import { INSTANT_SEARCH_API_KEY, INSTANT_SEARCH_APP_ID } from './config/constants';

aa('init', {
  appId: INSTANT_SEARCH_APP_ID,
  apiKey: INSTANT_SEARCH_API_KEY,
});